import React from 'react'
import { Link, useLocation } from 'react-router-dom'

import { singleTitleMapping } from './Components/TitleMappings';
import PageHeaderAction from './Components/PageHeaderAction'

const CommonBreadcrumb = () => {

    const location = useLocation();
    const pathname = location.pathname;
    const pathSegments = pathname.split('/').filter((segment) => segment);
    const singleTitle = singleTitleMapping[pathname];

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-2 page-header">
      
        <ul className="list-unstyled action d-flex align-items-center mb-0">
          <PageHeaderAction/>
        </ul>
    </div>
  )
}

export default CommonBreadcrumb